import {api} from "../http/apiClient"

const ApiOptIn = () => {
  const getOptIn = () => {
    return api.get("/get-opt-in/")
  }
  const postOptIn = () => {
    return api.post("/get-opt-in/", {})
  }

  return { getOptIn, postOptIn }
}

export default ApiOptIn
